<mat-form-field class="w-100" [hideRequiredMarker]="!attributeDefinition.isRequired">
  <mat-label>{{ label }}</mat-label>

  <mat-select [formControl]="control" multiple [required]="attributeDefinition.isRequired">
    <mat-option *ngIf="!options?.length" disabled>No options</mat-option>
    <mat-option *ngFor="let option of options" [value]="option.id">{{ option.value }}</mat-option>
  </mat-select>
  <button mat-icon-button matSuffix type="button" aria-label="Clear selection" (click)="clear($event)"
    [disabled]="control?.disabled || !control?.value?.length">
    <mat-icon>close</mat-icon>
  </button>
  <mat-error *ngIf="control?.invalid && (control?.dirty || control?.touched)">
    {{ getErrorMessage() }}
  </mat-error>
</mat-form-field>